module.exports = __webpack_public_path__ + "img/account-group.a9c6a0e0.svg";